/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Drawer, DrawerProps } from "@mui/material";
import { sidebarStyle } from "@/src/components/Sidebar/sidebarStyle";
import { mergeSx } from "@/src/utils/mergeSx";

export type SidebarProps = DrawerProps;

export default function Sidebar({ sx, children }: SidebarProps) {
  return (
    <Drawer variant={"permanent"} sx={mergeSx(sidebarStyle.sidebar, sx)} slotProps={{ paper: { sx: sidebarStyle.paper } }}>
      {children}
    </Drawer>
  );
}
